// extracted by mini-css-extract-plugin
module.exports = {"container":"ResultsHeaderToggle_container__17jnk"};